module.exports = __webpack_public_path__ + "media/welcome-message/webinar@1x-d6de4064.png";